import { FocusTrap, Space, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import NewFormModal from "../../components/new-form-modal";
import { TCronogramaForm } from "../../firestore";
// prettier-ignore
const EditarCronogramaDesafioModal = ({
  context,
  innerProps,
  id,
}: ContextModalProps<{ item: TCronogramaForm; data: TCronogramaDesafio[] | undefined, refetch: () => void; }>) => {
  const { data, refetch } = innerProps;

  /**
   * Handle add ignore area success
   */
  function onSuccess() {
    context.closeModal(id);
  }

  return (
    <FocusTrap active={true}>
      <Title order={4}>Editando imersão no desafio</Title>
      <Space h={"md"} />
      <NewFormModal data={data && data[0]} onSuccess={onSuccess} refetch={refetch} isUpdateCronogramaDesafio={true} />
    </FocusTrap>
  );
};

export default EditarCronogramaDesafioModal;
